// temp fields

export const tempTransactionHeadersList = [
    "Row Id",
    "Customer Id",
    "Status",
    "Position",
    "Profit",
    "Total Profit",
    "Date"
];
export const probTransactionHeadersList = [
    "Row Id",
    "Customer Id",
    "Status",
    "Position",
    "Entry Price",
    "Price Average",
    "Date"
];
export const permanentTransactionHeadersList = [
    "Row Id",
    "Customer Id",
    "API Message",
    "API Code",
    "Status",
    "Position",
    "Candle Index",
    "Entry Price",
    "Market Price",
    "Profit",
    "Total Profit",
    "Renko Pipes",
    "Timeframe",
    "Strategy Type",
    "Leverage",
    "Quantity",
    "Money In Use",
    "Approach",
    "Date",
    "timestamp"
];

export const tempSortOptions = {
    row_id: {
        id: 1,
        option: "row_id"
    },
    customer_id: {
        id: 2,
        option: "customer_id"
    },
    status: {
        id: 3,
        option: "status"
    },
    position: {
        id: 4,
        option: "position"
    },
    profit: {
        id: 5,
        option: "profit"
    },
    total_profit: {
        id: 6,
        option: "total_profit"
    },
    date_time: {
        id: 6,
        option: "date_time"
    }
};

export const realTimeTransactionsHeaderList = [
    "Symbol",
    "Market Price",
    "Market Side",
    "Entry Price",
    "Profit (%)",
    "Profit ($)",
    "trade status",
    "Elapsed Time",
    "Action"
];
export const dashboardAccountDetails = {
    feeTier: { propLabel: "Fee Tier" },
    updateTime: { propLabel: "Update Time" },
    multiAssetsMargin: { propLabel: "Multi Assets Margin" },
    totalInitialMargin: { propLabel: "Total Initial Margin" },
    totalMaintMargin: { propLabel: "Total Maint Margin" },
    totalWalletBalance: { propLabel: "Total WalletBalance" },
    totalUnrealizedProfit: { propLabel: "Total Unrealized Proit" },
    totalMarginBalance: { propLabel: "Total Margin Balance" },
    totalPositionInitialMargin: { propLabel: "Total Position Initial Margin" },
    totalOpenOrderInitialMargin: { propLabel: "Total Open Order InitialMargin" },
    totalCrossWalletBalance: { propLabel: "Total Cross Wallet Balance" },
    totalCrossUnPnl: { propLabel: "Total Cross UnPnl" },
    availableBalance: { propLabel: "Available Balance" },
    maxWithdrawAmount: { propLabel: "Max Withdraw Amount" }
};

export const openPositionsHeaderList = [
    "Symbol",
    "Initial Margin",
    "Maint Margin",
    "Unrealized Profit",
    "Position Initial Margin",
    "Open Order Initial Margin",
    "Leverage",
    "IsIsolated",
    "Entry Price",
    "Max Notional",
    "Position Side",
    "Position Amt",
    "Notional",
    "IsolatedWallet",
    "Update Time",
    "Bid Notional",
    "Ask Notional",
    "Action"
];
